import React from "react";
import { CardProps } from "./CardProps";
import { Link } from "react-router-dom";

const Card: React.FC<CardProps> = ({
  image,
  video,
  title,
  subtitle,
  description,
  titleLink,
  ctaText = "Learn More",
  ctaLink,
  variant = "image-left",
  className = "",
}) => {
  const isVideo = variant === "video" && video;
  const isRight = variant === "image-right";

  return (
    <div
      className={`bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row ${isRight ? "md:flex-row-reverse" : ""} ${className}`}
    >
      {/* Media */}
      <div className="md:w-1/2 h-80 md:h-auto relative bg-alt-blk">
        {isVideo ? (
          <video
            src={video}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        ) : image ? (
          <>
            {titleLink && (
              <Link to={titleLink} title={title}>
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover"
                />
              </Link>
            )}
            {!titleLink && (
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover"
              />
            )}
          </>
        ) : null}
      </div>

      {/* Content */}
      <div className="md:w-1/2 p-10 flex flex-col justify-center bg-ray">
        <h3 className="text-4xl font-bold text-alt-blk tracking-tight">
          {titleLink && <Link to={titleLink}>{title}</Link>}
          {!titleLink && <span>{title}</span>}
        </h3>
        {subtitle && <p className="text-mars font-semibold mt-2">{subtitle}</p>}

        <div
          className="mt-6 text-zinc-600 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>

        {ctaLink && (
          <Link
            to={ctaLink}
            className="mt-8 inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold text-center transition-all"
          >
            {ctaText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default Card;
